module.exports = __webpack_public_path__ + "img/ic_chevron_left_blue.ed6c7013.svg";